// 화면 간 공유 시간 포맷 헬퍼.
// 각 화면이 자기 도메인에 맞는 라벨 헬퍼(예: lastSeenLabel, invitedAgoLabel)는
// 직접 정의하되, 절대 시각 표시(hover title 등)와 감사 로그처럼 정확한 시각
// 가독성이 중요한 경우는 여기 정의된 헬퍼를 일관되게 사용한다.

// 전체 시각 hover용 — null이면 빈 문자열.
// admins/audit 표 셀의 title 속성에 일관되게 적용.
export function fullTimestamp(ts: string | Date | null | undefined): string {
  if (!ts) return "";
  return new Date(ts).toLocaleString("ko-KR", { dateStyle: "medium", timeStyle: "medium" });
}

// 날짜 전용 표시 — 협약일/등록일 같은 date 값에 사용.
// 값이 비었으면 dash, 잘못된 값이면 원본 그대로 fallback.
// "2024-11-04" → "2024년 11월 4일"
export function formatDate(ts: string | Date | null | undefined): string {
  if (!ts) return "—";
  const d = new Date(ts as string);
  if (isNaN(d.getTime())) return String(ts);
  return d.toLocaleDateString("ko-KR", { year: "numeric", month: "long", day: "numeric" });
}

// 감사 로그 표 셀용 — 절대 시각이지만 짧게.
// 오늘은 시:분만, 그 외엔 MM/DD HH:MM, 다른 해는 YYYY-MM-DD HH:MM.
// 감사 로그는 보통 시간순으로 정렬되어 표시되므로 상대 시간("3시간 전")보다
// 절대 시각이 조사 흐름에 더 유용 — 인접 행 간 간격 파악이 쉽다.
export function formatAuditTime(ts: string | Date | null | undefined): string {
  if (!ts) return "—";
  const t   = new Date(ts);
  const now = new Date();
  const sameDay  = t.toDateString() === now.toDateString();
  const sameYear = t.getFullYear() === now.getFullYear();
  const hhmm = `${String(t.getHours()).padStart(2, "0")}:${String(t.getMinutes()).padStart(2, "0")}`;
  if (sameDay)  return hhmm;
  const mmdd = `${String(t.getMonth() + 1).padStart(2, "0")}/${String(t.getDate()).padStart(2, "0")}`;
  if (sameYear) return `${mmdd} ${hhmm}`;
  return `${t.getFullYear()}-${mmdd} ${hhmm}`;
}
